import React, { useState } from "react";
import Icon from "../../Icon";
import IconButton from "../../IconButton";
import PasswordField from "../../PasswordField";

export default function MobilePasswordForm({
  callback,
  formField,
  onChange,
  passValidators,
  onBackPasswordClick,
}) {
  const [toThird, setToThird] = useState(false);
  return (
    <div
      className={`flex flex-col h-screen items-center space-y-6 mt-8 px-8 ${
        toThird && " duration-200  transform -translate-x-full  ease-out"
      }`}
    >
      <img
        src={
          process.env.NEXT_PUBLIC_THEME === "LT"
            ? "/Images/icon-semitruck.webp"
            : "/Images/flexport/semi-truck.webp"
        }
        width={130}
      />
      <h3 className=" mt-3 font-hkBold text-textMobile text-inputColor  ">
        Create Password
      </h3>
      <h3 className=" font-hkMedium text-textMobile text-center text-gray6 opacity-80text-inputColor opacity-30">
        {`Let’s make your security tight. Your password must have at least one symbol & 8 or more characters.`}
      </h3>

      <PasswordField
        width={"w-full"}
        height={"h-14"}
        value={formField.value}
        message={formField.message}
        error={formField.error}
        onInputChange={onChange}
      />
      <div className="flex flex-row items-center justify-center space-x-2 w-full absolute bottom-footerMobileM px-10">
        <Icon
          name="icon-backInactive"
          onClick={onBackPasswordClick}
          additionStyle={"mt-5"}
        />

        <IconButton
          title={"CONTINUE"}
          onButtonClick={async () => {
            let test = await passValidators();
            if (!test) {
              setTimeout(() => {
                callback(true);
              }, 200);
              setToThird(true);
            }
          }}
          width="w-full"
          disabled={formField.disabled}
          height="h-14"
        />
      </div>
    </div>
  );
}
